var map = {
	"./flag/ac.svg": "ff50",
	"./flag/ad.svg": "9f3f",
	"./flag/ae.svg": "0442",
	"./flag/af.svg": "7909",
	"./flag/ag.svg": "a062",
	"./flag/ai.svg": "f98a",
	"./flag/al.svg": "ca16",
	"./flag/am.svg": "64a9",
	"./flag/ao.svg": "8e26",
	"./flag/aq.svg": "2e41",
	"./flag/ar.svg": "5dc3",
	"./flag/as.svg": "ffda",
	"./flag/at.svg": "b46a",
	"./flag/au.svg": "a759",
	"./flag/aw.svg": "20bb",
	"./flag/ax.svg": "0aaa",
	"./flag/az.svg": "3ceb",
	"./flag/ba.svg": "633f",
	"./flag/bb.svg": "bfe1",
	"./flag/bd.svg": "b723",
	"./flag/be.svg": "2fc0",
	"./flag/bf.svg": "1a84",
	"./flag/bg.svg": "9f0e",
	"./flag/bh.svg": "f5a7",
	"./flag/bi.svg": "ae80",
	"./flag/bj.svg": "4f4b",
	"./flag/bl.svg": "8bad",
	"./flag/bm.svg": "c06a",
	"./flag/bn.svg": "79bc4",
	"./flag/bo.svg": "7d25",
	"./flag/bq.svg": "af35",
	"./flag/br.svg": "33e7",
	"./flag/bs.svg": "516f",
	"./flag/bt.svg": "ef10",
	"./flag/bv.svg": "a43b",
	"./flag/bw.svg": "8a2e",
	"./flag/by.svg": "faac",
	"./flag/bz.svg": "4f6b",
	"./flag/ca.svg": "7ea5",
	"./flag/cc.svg": "dcab",
	"./flag/cd.svg": "8973",
	"./flag/cf.svg": "f767",
	"./flag/cg.svg": "7fd5",
	"./flag/ch.svg": "4389",
	"./flag/ci.svg": "4842",
	"./flag/ck.svg": "1b87",
	"./flag/cl.svg": "aecf",
	"./flag/cm.svg": "d849",
	"./flag/cn.svg": "f2b7",
	"./flag/co.svg": "b9ed",
	"./flag/cp.svg": "e4b4",
	"./flag/cr.svg": "1385",
	"./flag/cu.svg": "5041",
	"./flag/cv.svg": "44b9",
	"./flag/cw.svg": "dbb5",
	"./flag/cx.svg": "29e9",
	"./flag/cy.svg": "67e0",
	"./flag/cz.svg": "97b4",
	"./flag/de.svg": "ece1",
	"./flag/dg.svg": "8ae7",
	"./flag/dj.svg": "f7fb",
	"./flag/dk.svg": "d2ad",
	"./flag/dm.svg": "6271",
	"./flag/do.svg": "3d52",
	"./flag/dz.svg": "4fc3",
	"./flag/ea.svg": "474b",
	"./flag/ec.svg": "50f8",
	"./flag/ee.svg": "57ce",
	"./flag/eg.svg": "efdb",
	"./flag/eh.svg": "f9a1",
	"./flag/er.svg": "9c51",
	"./flag/es-ct.svg": "1ba1",
	"./flag/es-ga.svg": "2e0e",
	"./flag/es.svg": "128c",
	"./flag/et.svg": "3e4d",
	"./flag/eu.svg": "41ba",
	"./flag/fi.svg": "0668",
	"./flag/fj.svg": "37bc",
	"./flag/fk.svg": "3f77",
	"./flag/fm.svg": "bcda",
	"./flag/fo.svg": "a288",
	"./flag/fr.svg": "5fc7",
	"./flag/ga.svg": "3e6d",
	"./flag/gb-eng.svg": "75f1",
	"./flag/gb-nir.svg": "583a",
	"./flag/gb-sct.svg": "78b2",
	"./flag/gb-wls.svg": "6813",
	"./flag/gd.svg": "f901",
	"./flag/ge.svg": "d439",
	"./flag/gf.svg": "bb44",
	"./flag/gg.svg": "948f",
	"./flag/gh.svg": "4796",
	"./flag/gi.svg": "9aee",
	"./flag/gl.svg": "a30f",
	"./flag/gm.svg": "6e3b",
	"./flag/gn.svg": "aa99",
	"./flag/gp.svg": "f622",
	"./flag/gq.svg": "82a7",
	"./flag/gr.svg": "f3b3",
	"./flag/gs.svg": "2847",
	"./flag/gt.svg": "8d5a",
	"./flag/gu.svg": "2b3a",
	"./flag/gw.svg": "0ff9",
	"./flag/gy.svg": "6bee",
	"./flag/hk.svg": "0991",
	"./flag/hm.svg": "e19c",
	"./flag/hn.svg": "5e79",
	"./flag/hr.svg": "3d58",
	"./flag/ht.svg": "5fa0",
	"./flag/hu.svg": "8005",
	"./flag/ic.svg": "7d6a",
	"./flag/id.svg": "1bb6",
	"./flag/ie.svg": "7e96",
	"./flag/il.svg": "718e",
	"./flag/im.svg": "2024",
	"./flag/in.svg": "be64",
	"./flag/io.svg": "83e5",
	"./flag/iq.svg": "81b2",
	"./flag/ir.svg": "d932",
	"./flag/is.svg": "cb2b",
	"./flag/it.svg": "9119",
	"./flag/je.svg": "31f6",
	"./flag/jm.svg": "5567",
	"./flag/jo.svg": "4a22",
	"./flag/jp.svg": "9028",
	"./flag/ke.svg": "2a63",
	"./flag/kg.svg": "5d60",
	"./flag/kh.svg": "9914",
	"./flag/ki.svg": "c02d",
	"./flag/km.svg": "2bd6",
	"./flag/kn.svg": "ad67",
	"./flag/kp.svg": "21f5",
	"./flag/kr.svg": "f6ac",
	"./flag/kw.svg": "6ea9",
	"./flag/ky.svg": "c7d0",
	"./flag/kz.svg": "1b96",
	"./flag/la.svg": "b2ad",
	"./flag/lb.svg": "1c1c",
	"./flag/lc.svg": "10a2",
	"./flag/li.svg": "b7c9",
	"./flag/lk.svg": "41a5",
	"./flag/lr.svg": "34c8",
	"./flag/ls.svg": "d389",
	"./flag/lt.svg": "7f50",
	"./flag/lu.svg": "b6eb",
	"./flag/lv.svg": "44b7",
	"./flag/ly.svg": "6f85",
	"./flag/ma.svg": "dc6a",
	"./flag/mc.svg": "81fe",
	"./flag/md.svg": "8bee",
	"./flag/me.svg": "ef3b",
	"./flag/mf.svg": "1d8a",
	"./flag/mg.svg": "bcad1",
	"./flag/mh.svg": "15df",
	"./flag/mk.svg": "44a8",
	"./flag/ml.svg": "4578",
	"./flag/mm.svg": "5f3f",
	"./flag/mn.svg": "f6db",
	"./flag/mo.svg": "76dd4",
	"./flag/mp.svg": "5b9a",
	"./flag/mq.svg": "2c81",
	"./flag/mr.svg": "d703",
	"./flag/ms.svg": "c0f5",
	"./flag/mt.svg": "2bb1",
	"./flag/mu.svg": "1738",
	"./flag/mv.svg": "07f9",
	"./flag/mw.svg": "3bcf",
	"./flag/mx.svg": "355e",
	"./flag/my.svg": "b802",
	"./flag/mz.svg": "5e64",
	"./flag/na.svg": "986f",
	"./flag/nc.svg": "fcf4",
	"./flag/ne.svg": "9d58",
	"./flag/nf.svg": "83e4",
	"./flag/ng.svg": "466e",
	"./flag/ni.svg": "17c4",
	"./flag/nl.svg": "cfff",
	"./flag/no.svg": "e53e",
	"./flag/np.svg": "174e",
	"./flag/nr.svg": "2c2d",
	"./flag/nu.svg": "64a0",
	"./flag/nz.svg": "c7bd",
	"./flag/om.svg": "b869",
	"./flag/pa.svg": "ed7c",
	"./flag/pe.svg": "c7c0",
	"./flag/pf.svg": "edd8",
	"./flag/pg.svg": "ec93",
	"./flag/ph.svg": "3ec9",
	"./flag/pk.svg": "5fd9",
	"./flag/pl.svg": "2c48",
	"./flag/pm.svg": "b169",
	"./flag/pn.svg": "6615",
	"./flag/pr.svg": "d24d",
	"./flag/ps.svg": "453a",
	"./flag/pt.svg": "3145",
	"./flag/pw.svg": "dee4",
	"./flag/py.svg": "cbcc",
	"./flag/qa.svg": "17a1",
	"./flag/re.svg": "f65d",
	"./flag/ro.svg": "d0d0",
	"./flag/rs.svg": "6b14",
	"./flag/ru.svg": "3cf4",
	"./flag/rw.svg": "ada3",
	"./flag/sa.svg": "d365",
	"./flag/sb.svg": "a471",
	"./flag/sc.svg": "5361",
	"./flag/sd.svg": "5756",
	"./flag/se.svg": "4ad5",
	"./flag/sg.svg": "0388",
	"./flag/sh.svg": "35f7",
	"./flag/si.svg": "ba1f",
	"./flag/sj.svg": "9bb4",
	"./flag/sk.svg": "bcc9",
	"./flag/sl.svg": "04cd",
	"./flag/sm.svg": "c855",
	"./flag/sn.svg": "aedc",
	"./flag/so.svg": "6595",
	"./flag/sr.svg": "174f",
	"./flag/ss.svg": "3ebd",
	"./flag/st.svg": "b742",
	"./flag/sv.svg": "6030",
	"./flag/sx.svg": "d448",
	"./flag/sy.svg": "3959",
	"./flag/sz.svg": "2726",
	"./flag/ta.svg": "aee9",
	"./flag/tc.svg": "cd3a",
	"./flag/td.svg": "6a46",
	"./flag/tf.svg": "a542",
	"./flag/tg.svg": "5f23",
	"./flag/th.svg": "d209",
	"./flag/tj.svg": "093a",
	"./flag/tk.svg": "ca8e",
	"./flag/tl.svg": "d592",
	"./flag/tm.svg": "ed9a",
	"./flag/tn.svg": "ef30",
	"./flag/to.svg": "d326",
	"./flag/tr.svg": "f5b5",
	"./flag/tt.svg": "463c",
	"./flag/tv.svg": "1af5",
	"./flag/tw.svg": "d85c",
	"./flag/tz.svg": "fb7b",
	"./flag/ua.svg": "77c6",
	"./flag/ug.svg": "838d",
	"./flag/uk.svg": "73b4",
	"./flag/um.svg": "bab9",
	"./flag/un.svg": "21e4",
	"./flag/us.svg": "c0c3",
	"./flag/uy.svg": "8fd3",
	"./flag/uz.svg": "7df2",
	"./flag/va.svg": "7d4a",
	"./flag/vc.svg": "2fee",
	"./flag/ve.svg": "d665",
	"./flag/vg.svg": "9a88",
	"./flag/vi.svg": "738f",
	"./flag/vn.svg": "7469",
	"./flag/vu.svg": "4944",
	"./flag/wf.svg": "c39e",
	"./flag/ws.svg": "8d7e",
	"./flag/xk.svg": "70e7",
	"./flag/xx.svg": "0ea0",
	"./flag/ye.svg": "a9b8",
	"./flag/yt.svg": "96ab",
	"./flag/za.svg": "f2d2",
	"./flag/zm.svg": "9937",
	"./flag/zw.svg": "0843",
	"./formats/csv.svg": "b445",
	"./formats/docx.svg": "ebf5",
	"./formats/gif.svg": "d707",
	"./formats/json.svg": "3156",
	"./formats/ods.svg": "53a6",
	"./formats/pdf.svg": "370c",
	"./formats/txt.svg": "9083",
	"./formats/xls.svg": "c5e3",
	"./formats/xlsx.svg": "d052",
	"./formats/xml.svg": "3bd5",
	"./global/active.svg": "9358",
	"./global/add.svg": "c5fc",
	"./global/additem.svg": "1300",
	"./global/app-menu.svg": "aed3",
	"./global/archived.svg": "a767",
	"./global/assets.svg": "e43d",
	"./global/bad-trash.svg": "da13",
	"./global/bag-add.svg": "8448",
	"./global/bag-change.svg": "95de",
	"./global/bag.svg": "5342",
	"./global/barCart.svg": "b96b",
	"./global/barcode.svg": "70b8",
	"./global/billing-info.svg": "4f6a",
	"./global/book.svg": "b898",
	"./global/bottom-arrow.svg": "8497",
	"./global/box-add.svg": "9b51",
	"./global/box-change.svg": "8daa",
	"./global/box-search.svg": "f70b",
	"./global/box.svg": "0fde",
	"./global/box2.svg": "1b04",
	"./global/buildings.svg": "af12",
	"./global/calendar-edit.svg": "1c42",
	"./global/calendar.svg": "45a6",
	"./global/cart.svg": "efe2",
	"./global/change.svg": "a649",
	"./global/chart-3.svg": "de7e",
	"./global/check.svg": "188c7",
	"./global/clock.svg": "93f1",
	"./global/close-circle.svg": "63e4",
	"./global/copy-success.svg": "ece4",
	"./global/copy.svg": "a873",
	"./global/customers.svg": "1a86",
	"./global/dashboard.svg": "790f",
	"./global/delete-round.svg": "6e59",
	"./global/delivery-info.svg": "4a72",
	"./global/diagram.svg": "0065",
	"./global/discount.svg": "fc58",
	"./global/dislike.svg": "3b43",
	"./global/document.svg": "24ac",
	"./global/download.svg": "80bf",
	"./global/draft.svg": "c50b",
	"./global/edit-sqare.svg": "b1bb",
	"./global/edit.svg": "5d23",
	"./global/filter.svg": "5953",
	"./global/flag.svg": "eb7e",
	"./global/gallery.svg": "0012",
	"./global/git-fork.svg": "2197",
	"./global/github.svg": "1f17",
	"./global/gitlab.svg": "fa211",
	"./global/home-trend-down.svg": "0b8e",
	"./global/incoming-building.svg": "38f9",
	"./global/incoming.svg": "2c54",
	"./global/info-circle.svg": "ce2b",
	"./global/invoice-add.svg": "5818",
	"./global/invoice-download.svg": "aaa8",
	"./global/invoice.svg": "ee56",
	"./global/left-arrow.svg": "5d63",
	"./global/left-arrow2.svg": "29ed",
	"./global/like.svg": "71ed",
	"./global/line.svg": "0986",
	"./global/lock.svg": "04d0",
	"./global/logout.svg": "f8ac",
	"./global/mail.svg": "e442",
	"./global/manual-incoming-building.svg": "41c4",
	"./global/map.svg": "f0c5",
	"./global/menu.svg": "bc7f",
	"./global/messages.svg": "ec8b",
	"./global/minus-circle.svg": "1a93",
	"./global/money-recive.svg": "cd1a",
	"./global/money-send.svg": "4b15",
	"./global/more.svg": "d0c7",
	"./global/mouse-circle.svg": "8782",
	"./global/no-image.svg": "a1df",
	"./global/notification.svg": "d848",
	"./global/order.svg": "839a",
	"./global/outgoing-building.svg": "3562",
	"./global/outgoing.svg": "14bb",
	"./global/partner-add.svg": "90e8",
	"./global/partners.svg": "e344",
	"./global/pin.svg": "84ba",
	"./global/plus-circle.svg": "190f",
	"./global/plus.svg": "6418",
	"./global/printer.svg": "2d89",
	"./global/puzzle.svg": "1dc5",
	"./global/receipt-discount.svg": "245a",
	"./global/refresh.svg": "1469",
	"./global/round-plus.svg": "ae6a",
	"./global/ruler.svg": "52a2",
	"./global/scanner.svg": "096ca",
	"./global/scissor.svg": "5f0a",
	"./global/search.svg": "5a1c",
	"./global/set-active.svg": "b2fb",
	"./global/settings.svg": "4a32",
	"./global/share.svg": "2e04",
	"./global/shield-check.svg": "e264",
	"./global/shield-cross.svg": "2f6a",
	"./global/shield-order.svg": "05e7",
	"./global/shield-search.svg": "4c7f",
	"./global/shield-security.svg": "322f",
	"./global/shield-tick.svg": "2c41",
	"./global/shield-x.svg": "b94d",
	"./global/shop.svg": "e621",
	"./global/star-filled.svg": "a633",
	"./global/star.svg": "0199",
	"./global/status-up.svg": "d43b",
	"./global/task-list.svg": "df9c",
	"./global/tick-circle.svg": "79d2",
	"./global/ticket-discount.svg": "a40d",
	"./global/timer-start.svg": "964a",
	"./global/tir.svg": "a0ce",
	"./global/trash.svg": "592f",
	"./global/truck-remove.svg": "d709",
	"./global/truck-tick.svg": "f857",
	"./global/truck-time.svg": "1cfc",
	"./global/unlock.svg": "c955",
	"./global/unpin.svg": "8b4a",
	"./global/user-search.svg": "724e",
	"./global/user-tick.svg": "19fa",
	"./global/video.svg": "5355",
	"./global/wallet-change.svg": "2de5",
	"./global/wallet-empty.svg": "f1df",
	"./global/wallet-money.svg": "b032",
	"./global/wallet-time.svg": "8cb8",
	"./global/warning.svg": "afa4",
	"./global/web.svg": "efb6b",
	"./settings/billing.svg": "9b8b",
	"./settings/briefcase.svg": "f2e0",
	"./settings/group.svg": "4381",
	"./settings/puzzle.svg": "2b76",
	"./settings/shopping.svg": "5cea",
	"./settings/tools.svg": "a0c5",
	"./settings/user.svg": "abb7",
	"./social/facebook.svg": "568a",
	"./social/google-maps.svg": "eeac",
	"./social/instagram.svg": "0eca",
	"./social/tiktok.svg": "76ec",
	"./social/trustpilot.svg": "3198"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";